/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
        
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three';
        
export default function Ruby({ position, rotation, scale, color='red' }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/models/ruby.gltf')
  return (
    <group ref={group} position={position} rotation={rotation} scale={scale} color={color} dispose={null}>
      <mesh geometry={nodes.Ruby.geometry}>
        <meshStandardMaterial color={color} side={THREE.DoubleSide}/>
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/ruby.gltf')